import apiEndpoints from "../helpers/apiEndpoints";

const MAILING_LIST_ID = 3;

export const sendSubscription = (data) => {
  const ENDPOINT = `${apiEndpoints.API_URL}/api/webhooks/mailing_list_subscription`;
  const headers = {
    Authorization: apiEndpoints.MAILING_LIST_SUBSCRIPTION_WEBHOOK_AUTH_TOKEN
  };

  const source = setSource(data);

  const params = {
    email: data.email,
    first_name: data.name,
    mailing_list_id: MAILING_LIST_ID,
    source: source
  };

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    body: JSON.stringify(params)
  });
};

const setSource = (data) => {
  if (data.menu_source === "publisher") {
    if (data.newsletter_opt_in && data.newsletter_opt_in.includes("yes")) {
      return "publisher_newsletter_signup";
    } else {
      return "publisher_contact_page";
    }
  }

  return "stackcommerce_newsletter_signup";
};
